import { Dispatch, SetStateAction, createContext } from 'react'

import { AIChatBotProps } from '.'
import { MessageProps } from './widget/messageList'

export type AIChatBotContextType = {
  avatar: string
  messageList: MessageProps[] | null
  setMessageList: Dispatch<SetStateAction<MessageProps[] | null>>
  fetchHistory: (v: string) => Promise<any>
  chatId: string
  setChatId: Dispatch<SetStateAction<string>>
  numberToShowHighlightMess: number
  starterAvatarSize?: number
  showWidget: boolean
  setShowWidget: Dispatch<SetStateAction<boolean>>
  expandWidget: boolean
  setExpandWidget: Dispatch<SetStateAction<boolean>>
} & Omit<AIChatBotProps, 'children'>

export const AIChatBotContext = createContext<AIChatBotContextType>(
  {} as AIChatBotContextType,
)
